import Navigation from './Navigation.svelte'


/*
What's Going On?
We are loading the nav JSON here instead of in the component, 
that way if there's any trouble gettin gthe data, we can just stop 
and leave the static nav as-is.
*/

const mountpoint = document.getElementById('navigation')
const lang = document.querySelector('html').lang || 'en'
const otherLang = lang=='en' ? 'fr' : 'en'

// these break on pages where meta[property="og:site_name"] is missing.... and the ?.___ shortcut doesn't work on iOS13
// const isHF = document.head.querySelector(`meta[property="og:site_name"]`).content == "Home Furniture" || false
// const alturl = document.head.querySelector(`link[rel="alternate"][hreflang^="${lang=='en'?'fr':'en'}-"]`).href || false

let isHF = document.head.querySelector(`meta[property="og:site_name"]`)
isHF = isHF ? isHF.content == "Home Furniture" : false

let alturl = document.head.querySelector(`link[rel="alternate"][hreflang^="${lang=='en'?'fr':'en'}-"]`)
alturl = alturl ? alturl.href : false


// hotfix
const urlPath = window.location.pathname
if (urlPath.includes('/on-sale')) {
	if (urlPath.includes(`/${lang}/`)) {
		alturl = urlPath.replace(`/${lang}/`, `/${otherLang}/`)
	} else {
		alturl = `/${otherLang}${urlPath}`

	}
}
// end hotfix


const preferredStore = JSON.parse(localStorage.preferredStore || sessionStorage.preferredStore || '{}') || {}
const storeCode = preferredStore.code || false




// hotfix: add storeCode to clearance link
let clearanceLinks = document.querySelectorAll('a[href$="liquidation?facetValueFilter=tenant~clearance-on-sale%3a"]')

if (storeCode && clearanceLinks) {
	for (var i = 0; i < clearanceLinks.length; ++i) {
		clearanceLinks[i].href += storeCode
		let contents = clearanceLinks[i].innerHTML
		contents = contents.replace("Deals", "Clearance").replace("Offres", "Liquidation")
		clearanceLinks[i].innerHTML = contents
	}
}
// end new


// TEMPORARY: inject menu into header
// let menuList = document.querySelector('ul.header-right-links')
// let menuNode = menuList.querySelector('a[href="#navigation"]')
// if (!menuList || !menuNode) {
// 	menuNode = document.createElement('li')
// 	menuNode.setAttribute('class', 'mz-navright-item singin-link hidden-xl hidden-lg hidden-md hidden-sm')
// 	menuNode.innerHTML = `
// 		<a href="#navigation" class="mz-utilitynav-link">
// 			<i class="far fa-bars"></i>
// 			<span class="icon-text">Menu</span>
// 		</a>`
// 	menuList.insertBefore(menuNode, menuList.children[1])
// }
// end TEMPORARY










// data loading function (async)
async function fetchNavigation() {
	// original (generic file)
	// const response = await fetch(`https://hh-website-json.storage.googleapis.com/nav.${isHF?'hf':lang}.json`);
	
	// new/temp (try store-specific file, fallback to generic if required)
	const response = await fetch(`https://hh-website-json.storage.googleapis.com/pricelist/nav.${storeCode}.${isHF?'hf':lang}.json`).then(payload => {
		// if payload is no good, respond with  fallback fetch (generic category tree)
		return payload.ok ? payload : fetch(`https://hh-website-json.storage.googleapis.com/nav.${isHF?'hf':lang}.json`)
	})
	const data = await response.json();
	return data;
}




fetchNavigation().then(data => {
		
	// if no data, just return-out
	if (!data || !data.length) { return }

	// if no mountpoint, just get outta here
	if (!mountpoint) { return }

	const authenticated = mountpoint.dataset.authenticated
	const label_products = mountpoint.dataset.labelProducts
	const links = mountpoint.querySelectorAll('a[data-preserve="links"]')
	const links_account = mountpoint.querySelectorAll('a[data-preserve="links_account"]')
	
	// clear out content
	mountpoint.innerHTML = null

	new Navigation({
		target: mountpoint,
		props: {
			lang: lang,
			alturl: alturl,
			data: data,
			preferredStore: preferredStore,
			authenticated: authenticated,
			label_products: label_products,
			links: Array.from(links),
			links_account: Array.from(links_account),
			isHF: isHF,
			mountpoint: mountpoint
		}
	})
	
})




/* hyjack the a[href="#navigation"] links */
const togglers = document.querySelectorAll('a[href="#navigation"]')
togglers.forEach(elem => {
	elem.addEventListener("click", e => {
		if (getComputedStyle(mountpoint).position!="fixed") return
		e.preventDefault();
		mountpoint.classList.toggle("active")
	})
});





/* when nav is engaged, prevent page from scrolling (in background) */
const navigationObserver = new MutationObserver((mutations) => {
	mutations.forEach(m => {
		if (m.type !== "attributes" && m.attributeName !== "class") return;
		const pageWrapper = document.getElementById('page-wrapper')
		if (m.target.classList.contains("active")) {
			pageWrapper.style.top = `-${window.scrollY}px`
			pageWrapper.style.position = 'fixed'
			pageWrapper.style.width = '100%'
		} else {
			const scrollY = pageWrapper.style.top
			pageWrapper.style.position = ''
			pageWrapper.style.top = ''
			window.scrollTo(0, parseInt(scrollY || '0') * -1)
		}
	});
});
navigationObserver.observe(mountpoint, {attributes: true});